import Phaser from 'phaser';
import { loadConfig } from '../../config/loadConfig';

const BIOME_TOKENS = ['meadow', 'riverbank', 'crystal'] as const;

function assetBiome(key: string, path: string): string | null {
  const hay = `${key}/${path}`.toLowerCase();
  for (const b of BIOME_TOKENS) {
    if (hay.includes(`/${b}/`) || hay.includes(`_${b}_`) || hay.includes(`_${b}.`) || hay.startsWith(`${b}_`) || hay.includes(`bg_${b}`) || hay.includes(`prop_${b}`)) {
      return b;
    }
  }
  // trail maps / backgrounds named with biome
  for (const b of BIOME_TOKENS) {
    if (hay.includes(b)) return b;
  }
  return null;
}

/**
 * Load current biome assets + shared (non-biome) assets.
 * Audio loads as ogg/m4a pair (Android prefers ogg).
 */
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('Preload');
  }

  preload(): void {
    const { assets, economy } = loadConfig();
    const site0 = economy.migration.sites[0];
    const currentBiome = (site0?.biome ?? 'meadow').toLowerCase();

    for (const asset of assets.assets) {
      const biome = assetBiome(asset.key, asset.path);
      if (biome && biome !== currentBiome) continue;

      if (asset.kind === 'image') {
        this.load.image(asset.key, `assets/${asset.path}`);
      } else if (asset.kind === 'audio') {
        const primary = `assets/${asset.path}`;
        const ogg = primary.replace(/\.m4a$/i, '.ogg');
        const m4a = primary.replace(/\.ogg$/i, '.m4a');
        // Prefer ogg then m4a so Android / desktop both resolve.
        this.load.audio(asset.key, [ogg, m4a]);
      }
    }
  }

  create(): void {
    this.scene.start('Mine');
  }
}
